import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { MessageService, SelectItem } from 'primeng/api';
import { Doctor_Termination_Model } from 'src/app/models/termination';
import { DoctorsService } from '../../../../services/doctors.service';
import { HttpErrorResponse } from '@angular/common/http';
import {
    ErrorModel,
    PromiseResult,
    ServerError
} from '../../../../models/PromiseResult';
import {
    name_input,
    address,
    city,
    phoneNumber,
    zipCode,
    textareaBox,
    dose_input,
    number_input,
    blockSpecialCharachters
} from 'src/app/constant/constant';
import { Title } from '@angular/platform-browser';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';
interface TerminationData {
    sr_no: number;
    user_guid: string;
    name: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    specialty_name: string;
    country_name: string;
    state_name: string;
    role: string;
    terminated_date: Date;
    additional_comments: string;
    is_active: boolean;
}

@TraceClassDecorator()
@Component({
    selector: 'app-termination',
    templateUrl: './termination.component.html',
    styleUrls: [
        '../../../../../assets/css/custom-egd.css',
        '../../../../../assets/css/custom-egd.css'
    ],
    encapsulation: ViewEncapsulation.None
})
export class TerminationComponent implements OnInit {
    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
    updateDialog: boolean = false;
    loading: boolean = false;
    termination: TerminationData[] = [];
    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    status: SelectItem[];
    Doctor: Doctor_Termination_Model;
    doctor_user_id: string;
    TZ: any = Intl.DateTimeFormat().resolvedOptions().timeZone;

    table_response: PromiseResult;
    table_error: ErrorModel;
    table_serverError: ServerError;
    table_posting: boolean;

    displayedColumns: string[] = [
        'sr_no',
        'name',
        'specialty_name',
        'country_name',
        'state_name',
        'status',
        'role',
        'terminated_date',
        'comments'
    ];
    refresh = false;
    slug: string = "";

    constructor(
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly messageService: MessageService,
        private readonly doctorService: DoctorsService,
        private readonly titleService: Title,
        private readonly providerstateService: ProviderStateService
    ) {
        
    }
    async edit(edit_doctor: TerminationData) {
        this.Cancel();

        // for(let i=0;i<this.termination.length;i++){
        //     if(this.termination[i].user_guid==user_guid){
        //         this.Doctor.edit_id=i
        //     }
        // }
        this.Doctor.user_guid = edit_doctor.user_guid;
        this.Doctor.is_active = edit_doctor.is_active;
        this.Doctor.additional_comments = edit_doctor.additional_comments;

        this.updateDialog = true;
    }
    Cancel() {
        this.updateDialog = false;
        this.Doctor = {
            edit_id: -1,
            user_guid: '',
            current_user_guid: this.doctor_user_id,
            additional_comments: '',
            is_active: null
        };
        this.ResetResultModels();
    }
    private ResetResultModels(): void {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    private ResetResultTableModels(): void {
        this.table_response = {
            success: null,
            error: null,
            data: null
        };
        this.table_serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    async ngOnInit() {
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Doctor Registration' },
            { label: 'Termination' }
        ]);
        this.titleService.setTitle('Dashboard - Termination');
        this.doctor_user_id = sessionStorage.getItem('userid');
        await this.getDoctorsList();
        this.status = [
            { label: 'Active', value: '1' },
            { label: 'Inactive', value: '2' }
        ];
        this.Cancel();
    }

    async Submit() {
        this.ResetResultModels();
        this.posting = true;
        await this.doctorService
            .UpdateStatus(this.Doctor)
            .toPromise()
            .then(async (result) => {
                // this.result=result;
                this.response = result;
                if (this.response.success) {
                    // this.termination[this.Doctor.edit_id-1].is_active=this.Doctor.is_active;
                    // this.termination[this.Doctor.edit_id-1].additional_comments=this.Doctor.additional_comments;
                    // this.termination[this.Doctor.edit_id-1].terminated_date=new Date();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Doctor Status changed successfully'
                    });
                    this.Cancel();
                } else if (!this.response.success) {
                    this.error = result.error;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        sticky: true,
                        detail: result.error.code + ' : ' + result.error.message
                    });
                }
                this.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            });
        await this.getDoctorsList();
    }

    async getDoctorsList() {
        this.ResetResultTableModels();
        this.loading = true;
        this.doctorService
            .GetAllDoctors()
            .toPromise()
            .then((result) => {
                this.table_response = result;
                let temp_objTermination: TerminationData[] = [];
                if (this.table_response.success) {
                    for (let i = 0; i < result.data.length; i++) {
                        //If Not Admin what to do
                        let objTermination: TerminationData = {
                            sr_no: i + 1,
                            user_guid: result.data[i].user_guid,
                            name:
                                result.data[i].first_name +
                                ' ' +
                               ( result.data[i].middle_name==null?'':result.data[i].middle_name) +
                                ' ' +
                                result.data[i].last_name,
                            first_name: result.data[i].first_name,
                            middle_name: (result.data[i].middle_name==null?'':result.data[i].middle_name),
                            last_name: result.data[i].last_name,
                            specialty_name:
                                result.data[i].d_specialty_type.specialty_name,
                            country_name:
                                result.data[i].country.country_name,
                            state_name: result.data[i].state_name,
                            role: result.data[i].role_type.title,
                            terminated_date:
                                result.data[i].terminated_date,
                            additional_comments:
                                result.data[i].additional_comments,
                            is_active: result.data[i].is_active
                        };
                        temp_objTermination.push(objTermination);
                    }
                    this.termination = temp_objTermination;
                    this.loading = false;
                } else if (!this.table_response.success) {
                    // this.error.message = result.error.message;
                    // this.messageService.add({
                    //     severity: "error",
                    //     summary: "Error",
                    //     sticky:true,
                    //     detail: result.error.code+" : "+result.error.message,
                    // });
                    this.loading = false;
                }
                this.loading = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.table_serverError = error.error;
                this.table_response.success = false;
                this.loading = false;
            });
    }
}
